import { SelectField } from '@/components/formBuilder/formFields/SelectField';
import { useEmailField } from '@/components/formBuilder/formFields/useEmailField';
import { useShowToast } from '@/hooks';
import { Box } from '@chakra-ui/react';
import React, { useRef } from 'react';
import { ModalWithForm } from '../modal';

export const EmailWithModal = ({
  emailModalActions = undefined,
  templateOptions = [],
  formik: parentFormik,
  initialValues,
  onSubmit,
  modalConfig = {},
  SelectedTemplateID = false,
}) => {
  const emailFormRef = useRef(null);
  const toast = useShowToast();

  const emailFields = useEmailField({
    formRef: initialValues?.sendRejectEmail
      ? { current: parentFormik }
      : emailFormRef,
    userEmailType: 'hiringTeam', // users or 'hiringTeam
    templateData: parentFormik?.values || {},
  });

  const emailFieldConfigs = [
    {
      id: 'emailFormConfig',
      type: 'wrapper',
      fields: emailFields,
      Wrapper: Box,
      wrapperProps: {
        border: '1px solid',
        borderColor: 'border-color',
        borderRadius: 'sm',
      },
    },
  ];

  const handleModalSubmit = (values) => {
    const { body, from, subject } = values;
    if (!from || !body || !subject) {
      toast({
        title: `From, subject and body is required`,
        description: '',
        status: 'error',
      });
    } else {
      // Ensure fromUserObject is included in the submitted values
      const formValues = initialValues?.sendRejectEmail
        ? parentFormik?.values
        : emailFormRef?.current?.values || values;
      // If fromUserObject is not set or doesn't match the from email, construct it based on the from value
      const currentFromUserObject =
        formValues?.fromUserObject || values.fromUserObject;

      const fromField = emailFields.find(
        (field) => field && 'name' in field && field.name === 'from'
      );

      const fromFieldOptions =
        fromField && 'options' in fromField ? fromField.options : [];

      const matchedUserObject = fromFieldOptions.find(
        (opt) => opt && typeof opt === 'object' && opt.email === from
      );

      const updatedFromUserObject =
        currentFromUserObject && currentFromUserObject.email === from
          ? currentFromUserObject
          : matchedUserObject || {};

      const updatedValues = {
        ...values,
        fromUserObject: updatedFromUserObject,
      };

      onSubmit(updatedValues);
      emailModalActions?.onClose();
    }
  };

  return (
    <ModalWithForm
      isOpen={emailModalActions?.isOpen}
      onClose={emailModalActions?.onClose}
      formConfig={emailFieldConfigs}
      primaryCtaText="Customize"
      modalContentProps={{
        minW: '724px',
        position: 'fixed',
      }}
      modalBodyProps={{
        maxH: '70vh',
        overflowY: 'auto',
      }}
      showCloseButton={false}
      initialValues={initialValues}
      renderHeaderCta={() => {
        return (
          <Box minW="250px">
            <SelectField
              item={{
                name: 'selectedTemplate',
                type: 'select',
                label: 'Select reject email template',
                placeholder: 'Select email template',
                labelKey: 'name',
                isConditional: true,
                conditionConfig: { field: 'sendRejectEmail', value: true },
                validationType: 'object',
                errorMessage: 'Email template is required',
                options: templateOptions?.map((opt) => ({
                  ...opt,
                  label: opt.name,
                  value: SelectedTemplateID ? opt.id : opt,
                })),
              }}
            />
          </Box>
        );
      }}
      headerText="Customize rejection email"
      subHeaderText={`Write your custom rejection email for only selected candidate`}
      handleSubmit={handleModalSubmit}
      {...modalConfig}
    />
  );
};
